module.exports = __webpack_public_path__ + "static/media/house-transparent.f0bc0814.png";